import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75 7.25H13V8.75H8.75V13H7.25V8.75H3V7.25H7.25V3H8.75V7.25Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
